export default __webpack_public_path__ + "static/media/BrixSansLight.c3f33613.woff";